const componentHeights = {
	nav: "75px",
	footer: "75px",

	navV2: "125px",
	footer2: "50px"
}

export default componentHeights
